<app-payment-panel-paygreen-generic type="PAYGREEN_TRD"></app-payment-panel-paygreen-generic>
